import { getAPI , putAPI } from "../../api";
import { REACT_APP_CANDIDATE_FREELANCER } from "../../utils/common"

export async function getAssessmentRequestDetails(requestId: any) {
    const Details = getAPI( REACT_APP_CANDIDATE_FREELANCER + `/assessment-request-details/${requestId}`)
    return Details
}

export async function updateCompanyRatingsfromEmailRedirection(requestId: any , data: any) {
    const Details = putAPI( REACT_APP_CANDIDATE_FREELANCER + `/company-rating?eventType=emailSubmit&requestId=${requestId}`,data)
    return Details
}

// https://dev-api.ellow.io/candidate-freelancer/company-rating?eventType=emailSubmit&requestId=10a24a89-164a-48e5-8fc6-ad976f3b5cb4
